import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    // 1. Get saved theme or default to 'light'
    const savedTheme = localStorage.getItem("theme") || "light"

    // 2. Apply theme immediately (no transition on load)
    document.documentElement.setAttribute("data-theme", savedTheme)

    // 3. Sync the checkbox state
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.checked = (savedTheme === "dark")
    }
  }

  switch(event) {
    const newTheme = event.target.checked ? "dark" : "light"

    // Define the update logic as a function
    const updateTheme = () => {
      document.documentElement.setAttribute("data-theme", newTheme)
      localStorage.setItem("theme", newTheme)
    }

    // 4. Use View Transition if supported, otherwise fallback to instant swap
    if (!document.startViewTransition) {
      updateTheme()
      return
    }

    // This takes a screenshot of the old theme, updates the DOM,
    // and cross-fades to the new theme.
    document.startViewTransition(() => {
      updateTheme()
    })
  }
}